export default __webpack_public_path__ + "static/media/brand.fc06206a.png";